
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import deleteDialog from "@/views/ai-builder-component/components/delete-dialog.vue";

@Component({
  components: { deleteDialog, HinaSwitch }
})
export default class ComponentIntroduceCard extends Vue {
  @Prop({ default: "" }) detectName!: string;
  @Prop({ default: "" }) detectMethods!: string;
  @Prop({ default: true }) hasSwitch!: boolean;
  @Prop({ default: 0 }) use!: number;
  @Prop({ default: 1 }) activeValue!: number | boolean;
  @Prop({ default: 2 }) inactiveValue!: number | boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "" }) confirm!: string;

  selfUse: number | boolean = 0;

  @Watch("use", { immediate: true })
  onUseChange(val: number | boolean) {
    this.selfUse = val;
  }

  beforeChange() {
    this.$emit("beforeChange");
  }

  onMainSwitchChange(val: number) {
    this.$emit("update:use", val);
    this.$emit("change", val);
  }

  showConfirm = false;

  handleConfirm() {
    this.showConfirm = true;
  }

  handleOkConfirm() {
    this.$emit("update:use", this.inactiveValue);
    this.showConfirm = false;
  }
}
